import React from 'react';
import Sym from '../components/Sym';

/**
 * Ilustraciones animadas de las tarjetas de características — portadas fielmente
 * del template de diseño (landing/PaySlip.dc.html). Usan los keyframes ls2-*
 * ya definidos en landing2.css. Se muestran dentro del "well" de 168px.
 * Clave = nombre del icono de la feature (ver FEATURES en Features2.jsx).
 */

const paper = { background: '#fff', borderRadius: 8, boxShadow: '0 10px 22px -8px rgba(0,0,0,.6)' };
const line = (w, c = '#E1E7F2') => ({ height: 5, width: w, background: c, borderRadius: 3 });

// 1 · Descarga automática del SAT — recibo cae del SAT hacia una "canasta"
const SatDrop = () => (
  <>
    <div style={{ position: 'absolute', top: 18, left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', gap: 7, background: '#12203C', border: '1px solid rgba(111,160,255,.3)', borderRadius: 999, padding: '6px 13px', zIndex: 4 }}>
      <Sym name="cloud" size={17} color="#6FA0FF" />
      <span style={{ font: "700 .72rem 'IBM Plex Mono'", letterSpacing: '.08em', color: '#8FB4FF' }}>SAT</span>
    </div>
    <div style={{ position: 'absolute', top: 44, left: '50%', transform: 'translateX(-50%)', width: 2, height: 34, background: 'repeating-linear-gradient(180deg,#2F6BFF 0 4px,transparent 4px 9px)', opacity: 0.5 }} />
    <div style={{ position: 'absolute', top: 46, left: '50%', marginLeft: -28, animation: 'ls2-satDrop 2.8s cubic-bezier(.5,0,.5,1) infinite', zIndex: 3 }}>
      <div style={{ ...paper, width: 56, height: 70, padding: 9, display: 'flex', flexDirection: 'column', gap: 5 }}>
        <div style={line('70%', '#C9D3E6')} /><div style={line('90%')} /><div style={line('50%')} />
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
          <span style={{ width: 15, height: 15, borderRadius: '50%', background: '#2F6BFF', display: 'grid', placeItems: 'center' }}><Sym name="check" size={11} color="#fff" /></span>
        </div>
      </div>
    </div>
    <div style={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', width: 92, height: 22, border: '2px solid rgba(111,160,255,.4)', borderTop: 'none', borderRadius: '0 0 12px 12px' }} />
  </>
);

// 2 · Entrega a cada colaborador — doc → 3 líneas → 3 avatares con check
const Avatar = ({ ini, delay }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <div style={{ width: 40, height: 2, background: '#2F6BFF', transformOrigin: 'left', animation: `ls2-deliverLine 3s ease-in-out ${delay}s infinite` }} />
    <div style={{ position: 'relative', width: 30, height: 30, borderRadius: '50%', background: '#12203C', border: '1px solid rgba(111,160,255,.4)', display: 'grid', placeItems: 'center', font: "700 .6rem 'IBM Plex Mono'", color: '#8FB4FF' }}>
      {ini}
      <span style={{ position: 'absolute', right: -4, bottom: -4, width: 15, height: 15, borderRadius: '50%', background: '#2F6BFF', display: 'grid', placeItems: 'center', animation: `ls2-popCheck 3s ease-in-out ${delay}s infinite` }}><Sym name="check" size={10} color="#fff" /></span>
    </div>
  </div>
);
const Delivery = () => (
  <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 22px' }}>
    <div style={{ ...paper, width: 52, height: 66, padding: 8, display: 'flex', flexDirection: 'column', gap: 5, zIndex: 2, flexShrink: 0 }}>
      <div style={line('80%', '#C9D3E6')} /><div style={line('95%')} /><div style={line('60%')} />
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Avatar ini="MR" delay={0} /><Avatar ini="JM" delay={0.25} /><Avatar ini="AG" delay={0.5} />
    </div>
  </div>
);

// 3 · Portal 24/7 — teléfono con feed de recibos que hace scroll
const FeedRow = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,.92)', borderRadius: 6, padding: '6px 7px' }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <div style={{ height: 4, width: 32, background: '#B7C2D8', borderRadius: 2 }} />
      <div style={{ height: 3, width: 20, background: '#D6DEEC', borderRadius: 2 }} />
    </div>
    <Sym name="download" size={13} color="#2F6BFF" />
  </div>
);
const PortalFeed = () => (
  <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
    <div style={{ position: 'relative', width: 100, height: 140, background: '#0A1326', border: '5px solid #1A2A4A', borderRadius: 18, overflow: 'hidden', boxShadow: '0 16px 32px -12px rgba(0,0,0,.7)' }}>
      <div style={{ height: 24, background: '#2F6BFF' }} />
      <div style={{ position: 'relative', height: 106, overflow: 'hidden', padding: 7 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 7, animation: 'ls2-feedScroll 4.5s linear infinite' }}>
          {Array.from({ length: 8 }).map((_, i) => <FeedRow key={i} />)}
        </div>
      </div>
    </div>
    <div style={{ position: 'absolute', top: 20, right: 26, background: '#12203C', border: '1px solid rgba(111,160,255,.5)', borderRadius: 999, padding: '4px 9px', font: "700 .66rem 'IBM Plex Mono'", color: '#8FB4FF', animation: 'ls2-badgeGlow 2.4s ease-in-out infinite', zIndex: 4 }}>24/7</div>
  </div>
);

// 4 · Panel para administradores — spinner + barras que crecen
const DashboardBars = () => (
  <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
    <div style={{ width: 154, background: '#0B1526', border: '1px solid rgba(255,255,255,.08)', borderRadius: 12, padding: 13, boxShadow: '0 16px 30px -14px rgba(0,0,0,.6)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ height: 6, width: '60%', background: '#33436A', borderRadius: 3, marginBottom: 5 }} />
          <div style={{ height: 5, width: '38%', background: '#243250', borderRadius: 3 }} />
        </div>
        <div style={{ width: 22, height: 22, border: '3px solid rgba(111,160,255,.2)', borderTopColor: '#2F6BFF', borderRadius: '50%', animation: 'ls2-spin 1.7s linear infinite' }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 9, height: 56 }}>
        {[0, 0.3, 0.6, 0.9].map((d) => (
          <div key={d} style={{ flex: 1, height: '100%', background: 'linear-gradient(#6FA0FF,#2F6BFF)', borderRadius: 5, transformOrigin: 'bottom', animation: `ls2-barGrow 2.2s ease-in-out ${d}s infinite` }} />
        ))}
      </div>
    </div>
  </div>
);

// 5 · Histórico y respaldo — stack de docs, el de arriba "levita" + badge history
const HistoryStack = () => (
  <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
    <div style={{ position: 'relative', width: 130, height: 96 }}>
      <div style={{ position: 'absolute', top: 14, left: 20, width: 60, height: 74, background: '#20334F', borderRadius: 9 }} />
      <div style={{ position: 'absolute', top: 8, left: 10, width: 60, height: 74, background: '#2B3F5F', borderRadius: 9 }} />
      <div style={{ position: 'absolute', top: 2, left: 0, width: 60, height: 74, ...paper, padding: 9, display: 'flex', flexDirection: 'column', gap: 5, animation: 'ls2-liftTop 3.2s ease-in-out infinite' }}>
        <div style={line('75%', '#C9D3E6')} /><div style={line('92%')} /><div style={line('55%')} />
      </div>
      <div style={{ position: 'absolute', right: -4, bottom: -4, width: 44, height: 44, borderRadius: '50%', background: '#0A1326', display: 'grid', placeItems: 'center' }}>
        <div style={{ position: 'absolute', inset: 0, border: '2.5px dashed rgba(111,160,255,.55)', borderRadius: '50%', animation: 'ls2-spin 6s linear infinite' }} />
        <Sym name="history" size={22} color="#6FA0FF" />
      </div>
    </div>
  </div>
);

// 6 · Búsqueda al instante — 3 filas, una resaltada + lupa que barre
const SearchSweep = () => (
  <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
    <div style={{ position: 'relative', width: 158 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--well-row)', borderRadius: 8, padding: '8px 10px' }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--marquee)' }} /><div style={{ height: 5, width: 70, background: '#33436A', borderRadius: 3 }} /></div>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8, background: 'var(--well-row)', borderRadius: 8, padding: '8px 10px' }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6FA0FF' }} /><div style={{ height: 5, width: 84, background: '#5877A8', borderRadius: 3 }} />
          <span style={{ position: 'absolute', inset: 0, border: '1.5px solid #2F6BFF', borderRadius: 8, background: 'rgba(47,107,255,.12)', animation: 'ls2-rowHi 3.2s ease-in-out infinite' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--well-row)', borderRadius: 8, padding: '8px 10px' }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--marquee)' }} /><div style={{ height: 5, width: 60, background: '#33436A', borderRadius: 3 }} /></div>
      </div>
      <div style={{ position: 'absolute', top: -4, left: 0, animation: 'ls2-sweep 3.2s ease-in-out infinite', zIndex: 3 }}>
        <div style={{ width: 28, height: 28, border: '3px solid #6FA0FF', borderRadius: '50%', background: 'rgba(47,107,255,.15)', boxShadow: '0 0 12px rgba(47,107,255,.4)' }} />
        <div style={{ position: 'absolute', bottom: -2, right: -5, width: 11, height: 3.5, background: '#6FA0FF', borderRadius: 2, transform: 'rotate(45deg)' }} />
      </div>
    </div>
  </div>
);

const ILLUSTRATIONS = {
  cloud_download: SatDrop,
  groups: Delivery,
  smartphone: PortalFeed,
  dashboard: DashboardBars,
  history: HistoryStack,
  search: SearchSweep,
};

export default ILLUSTRATIONS;
